'use client';

import React from 'react';
import ContactForm from './ContactForm';
import ContactInfo from './ContactInfo';
import ConversationPreparation from './ConversationPreparation';
import TrustIndicators from './TrustIndicators';
import FAQSection from './FAQSection';

const ContactInteractive: React.FC = () => {
  const handleScrollToForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const formElement = document.getElementById('contact-form');
    if (formElement) {
      const yOffset = -100; // Offset for header
      const y = formElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <>
      <section className="py-12 sm:py-16 lg:py-24 bg-background">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 sm:gap-12">
            <div className="lg:col-span-2">
              <ContactForm />
            </div>
            <div className="lg:col-span-1">
              <ContactInfo />
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 sm:py-16 lg:py-24 bg-surface">
        <div className="container mx-auto px-4 sm:px-6">
          <ConversationPreparation />
        </div>
      </section>

      <section className="py-12 sm:py-16 lg:py-24 bg-background">
        <div className="container mx-auto px-4 sm:px-6">
          <TrustIndicators />
        </div>
      </section>

      <section className="py-12 sm:py-16 lg:py-24 bg-surface">
        <div className="container mx-auto px-4 sm:px-6">
          <FAQSection />
        </div>
      </section>

      <section className="py-12 sm:py-16 lg:py-24 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 text-institutional">
              Ready to Begin the Conversation?
            </h2>
            <p className="text-base sm:text-lg text-gray-700 mb-6 sm:mb-8 leading-relaxed px-2">
              If you are a senior decision-maker exploring strategic advisory support for institutional transformation, we invite you to request an initial conversation. This is a substantive discussion designed to assess mutual fit and explore how we might support your organization's long-term success.
            </p>
            <a
              href="#contact-form"
              onClick={handleScrollToForm}
              className="inline-block px-6 sm:px-8 py-3 sm:py-4 bg-institutional text-white font-semibold rounded-md hover:bg-institutional/90 transition-fast institutional-shadow text-sm sm:text-base"
            >
              Request Initial Conversation
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactInteractive;